<template>
    <div class="box">
        <div class="page-content-container">
            <div class="page-content-header">
                <div class="page-header-block"></div>
                <div v-if="userType == 2" class="page-content-header-item"
                    :class="listMode == 'Report-Overview' ? 'page-content-header-item-active' : 'page-content-header-item'"
                    @click="handleMode('Report-Overview')">
                    报告总览
                </div>
                <div :class="listMode == 'study-report-member' ? 'page-content-header-item-active' : 'page-content-header-item'"
                    @click="handleMode('study-report-member')">
                    成员情况
                </div>
                <div class="page-content-header-item"
                    :class="listMode == 'study-report-course' ? 'page-content-header-item-active' : 'page-content-header-item'"
                    @click="handleMode('study-report-course')">
                    课程情况
                </div>
            </div>
            <div class="page-content-wrapper">
                <div class="page-content">
                    <div class="page-title-wrapper">
                        <!-- 成员情况查询信息 -->
                        <div class="study-report-member-input-wrapper"
                            v-if="listMode === 'study-report-member' && showSort">
                            <el-form label-width="100px">
                                <el-row :gutter="20">
                                    <el-col :span="11">
                                        <el-form-item label="公司部门">
                                            <el-cascader v-model="companyValue" :options="companyOptions" filterable
                                                clearable collapse-tags
                                                :props="{ checkStrictly: true, label: 'deptName', value: 'deptId', multiple: true }"></el-cascader>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="姓名/手机号">
                                            <el-input v-model="searchVal"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="study-report-member-input-btn" @click="handleSearch">
                                            <i class="el-icon-search input-btn-icon"></i>
                                            <span class="input-btn-label">搜索</span>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                        <!-- 课程情况查询信息 -->
                        <div class="page-mode-input-wrapper" v-if="listMode === 'study-report-course'">
                            <div class="page-mode-input">
                                <el-input v-model="searchVal" placeholder="请输入搜索内容"></el-input>
                            </div>
                            <div class="input-btn" @click="handleSearch">
                                <i class="el-icon-search input-btn-icon"></i>
                                <span class="input-btn-label">搜索</span>
                            </div>
                        </div>
                        <!-- 报告总览查询信息 -->
                        <div v-if="listMode === 'Report-Overview'">
                            <div style="color: #f59a23;font-weight: 500;font-size: 20px;">
                                温馨提示:您所在团队学习情况数据已自动保存，在下方选择月份后点击预约生成，系统将快速查询数据生成该月报告!</div>
                            <div style='margin-top: 30px;'>
                                <!-- <el-date-picker value-format="yyyyMM" v-model="month" type="month" placeholder="选择月份">
                                </el-date-picker> -->

                                <el-select v-model="month" clearable placeholder="请选择月份">
                                    <el-option v-for="item in monthList" :key="item.dictCode" :label="item.dictLabel"
                                        :value="item.dictValue">
                                    </el-option>
                                </el-select>
                                <el-button style="margin-left: 20px;" type="primary" @click="Appointment_generation
                                ">预约生成</el-button>
                            </div>
                        </div>
                    </div>
                    <!-- 成员情况学习进度定位 -->
                    <div class="sort-wrap" @click="sortChange" v-if="listMode === 'study-report-member' && showSort">
                        <span>学习进度</span>
                        <i :class="`${sortDirect === 'desc' ? 'el-icon-bottom' : 'el-icon-top'} sort-btn`" />
                    </div>
                    <!-- 成员情况列表/查看更多 -->
                    <div v-if="listMode == 'study-report-member'" class="video-list">
                        <List :mode="listMode" :tableData="tableData"></List>
                        <div v-if="tableData.length > 0 && currentPageMember < totalPagesMember" class="view-more-btn"
                            @click="viewMore">
                            查看更多

                        </div>
                        <div style="height: 10px;"></div>
                    </div>
                    <!-- 课程情况列表/查看更多 -->
                    <div v-if='listMode == "study-report-course"' class="video-list">
                        <List :mode="listMode" :tableData="tableData1"></List>
                        <div v-if="tableData1.length > 0 && currentPageStudy < totalPagesStudy" class="view-more-btn"
                            @click="viewMore">
                            查看更多
                        </div>
                        <div style="height: 10px;"></div>
                    </div>
                    <!-- 报告总览列表/查看更多 -->
                    <div v-if='listMode == "Report-Overview"' class="video-list">
                        <List :mode="listMode" :tableData="tableData2"></List>
                        <div v-if="tableData2.length > 0 && currentPageOverview < totalPagesOverview" class="view-more-btn"
                            @click="viewMore">
                            查看更多
                        </div>
                        <div style="height: 10px;"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getMemberList, getCourseList, getOrganizationalStructure, generate, studylist, reGenerate, getDicts } from '@/api/index.js';
import List from '@/components/List.vue'
export default {
    name: '',
    components: {
        List
    },
    data() {
        return {
            userType: null, //判断是否是管理员 "role": 0, //用户角色(0:普通用户；1：管理员；2：超级管理员）
            monthList: null,
            month: "",
            listMode: localStorage.getItem('listMode') ? localStorage.getItem('listMode') : "study-report-member",
            activeTab: "record",
            searchVal: "",
            companyValue: [],
            companyOptions: [],
            tableData: [],
            tableData1: [],
            tableData2: [],
            dept: "",
            token: "",
            currentPageStudy: 1,
            totalPagesStudy: 1,
            currentPageMember: 1,
            totalPagesMember: 1,
            currentPageOverview: 1,
            totalPagesOverview: 1,

            showSort: false,
            sortDirect: 'desc',
        }
    },
    created() {
        this.tableData = [];
        // this.listMode = this.modeVal;
        // this.dept = this.$route.params.dept;
        // this.token = this.$route.params.token;
        this.token = window.localStorage.getItem('token');
        this.dept = window.localStorage.getItem('dept');
        var user = JSON.parse(localStorage.getItem('user'))
        this.userType = user ? user.role : null
        console.log(user, this.userType, 'user')
        this.getyf()

    },
    mounted() {
        var activeMode = this.listMode;
        this.userInfo = JSON.parse(window.localStorage.getItem('user'));
        if (this.userInfo && this.userInfo.role !== 0) {
            this.showSort = true
        }
        this.handleMode(activeMode);
    },
    methods: {
        getyf() {
            getDicts({ "dictType": "studyMonths" }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200 || res.code == 0) {
                    this.monthList = res.data
                    console.log(res)
                }
            })
        },
        //预约报告
        Appointment_generation() {
            let _this = this
            if (!this.month) {
                this.$message.error("请选择月份");
                return;
            }
            console.log(this.month, 'this.month ')
            generate({
                studyMonth: this.month,
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    if (res.data.exist == 1) {
                        let id = res.data.id
                        this.$confirm('该月份已生成报告，是否重新生成?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            reGenerate({
                                id: id,
                            }, {
                                Authorization: this.token,
                                DeptId: this.dept
                            }).then(res => {
                                if (res.code == 200) {
                                    this.currentPageOverview = 1;
                                    this.tableData2 = [];
                                    this.$message.success("重新生成成功");
                                    this.getOverviewData()
                                }
                            }).catch(err => {
                                //   console.log(err);
                            });
                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消'
                            });
                        });


                    } else {
                        this.currentPageOverview = 1;
                        this.tableData2 = [];
                        this.$message.success("预约生成成功");
                        this.getOverviewData()
                    }


                } else {
                    this.$message.error(res.msg);
                }

            }).catch(err => {
                //   console.log(err);
            });
        },


        handleMode(target) {
            this.searchVal = '';
            this.listMode = target;
            localStorage.setItem('listMode', target)

            switch (target) {
                case "study-report-member":
                    this.tableData = [];
                    this.currentPageMember = 1;
                    this.getOrganizationalStructure()
                    this.getMemberData();
                    break;
                case "study-report-course":
                    this.tableData1 = [];
                    this.currentPageStudy = 1;
                    this.getCourseData();
                    break;
                case "Report-Overview":

                    this.tableData2 = [];
                    this.currentPageOverview = 1;
                    this.getOverviewData();
                    break;
            }
        },
        handleTab(target) {
            this.activeTab = target;
        },
        // 获取公司部门数据
        getOrganizationalStructure() {
            getOrganizationalStructure({
                keyword: '',
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.companyOptions = res.data.deptList;
                    // this.resetData(data.deptList);
                }
                return;
            }).catch(err => {
                //   console.log(err);
            });
        },
        //成员情况列表
        getMemberData() {
            let orgDeptIdList = []
            if (this.companyValue && this.companyValue.length !== 0) {
                this.companyValue.forEach((item) => {
                    if (item && item.length !== 0) {
                        orgDeptIdList.push(item[item.length - 1])
                    }
                })
            }
            getMemberList({
                "deptId": this.dept,
                "keyword": this.searchVal,
                "orgDeptIdList": orgDeptIdList,
                "sortDirect": this.sortDirect,
                "pageNum": this.currentPageMember,
                "pageSize": 10,
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data.list;
                    var lastData = this.tableData;
                    this.tableData = lastData.concat(data);
                    this.totalPagesMember = res.data.totalPages;
                }
                return;
            }).catch(err => {
                //   console.log(err);
            });
        },

        //课程情况列表
        getCourseData() {
            getCourseList({
                "deptId": this.dept,
                "keyword": this.searchVal,
                "pageNum": this.currentPageStudy,
                "pageSize": 10,
                "sortDirect": "",
                "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data.list;
                    var tableArr = this.tableData1;
                    this.tableData1 = tableArr.concat(data);
                    this.totalPagesStudy = res.data.totalPages;
                }
                return;
            }).catch(err => {
                //   console.log(err);
            });
        },
        //报告列表

        getOverviewData() {
            studylist({

                "pageNum": this.currentPageOverview,
                "pageSize": 10,

            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.rows;
                    var tableArr2 = this.tableData2;
                    this.tableData2 = tableArr2.concat(data);
                    this.totalPagesOverview = res.totalPages;
                }
                return;
            }).catch(err => {
                //   console.log(err);
            });
        },
        // 排序改变
        sortChange() {
            switch (this.sortDirect) {
                case 'desc':
                    this.sortDirect = 'asc'
                    break;
                case 'asc':
                    this.sortDirect = 'desc'
                    break;

                default:
                    break;
            }
            this.handleSearch()
        },
        handleSearch() {
            var mode = this.listMode;


            switch (mode) {
                case "study-report-member":
                    this.tableData = [];
                    this.currentPageMember = 1;
                    this.getMemberData();
                    break;
                case "study-report-course":
                    this.tableData1 = [];
                    this.currentPageStudy = 1;
                    this.getCourseData();
                    break;
                case "Report-Overview":
                    this.currentPageOverview = 1;
                    this.tableData2 = [];
                    this.getOverviewData();
                    break;
            }
        },
        viewMore() {
            switch (this.listMode) {
                case "study-report-member":
                    var currentPageMember = this.currentPageMember;
                    if (currentPageMember < this.totalPagesMember) {
                        this.currentPageMember = currentPageMember + 1;
                        this.getMemberData();
                    } else {
                        this.$message({
                            message: '没有更多了',
                            type: 'warning'
                        });
                    }
                    break;
                case "study-report-course":
                    var currentPageStudy = this.currentPageStudy;
                    if (currentPageStudy < this.totalPagesStudy) {
                        this.currentPageStudy = currentPageStudy + 1;
                        this.getCourseData();
                    } else {
                        this.$message({
                            message: '没有更多了',
                            type: 'warning'
                        });
                    }
                    break;
                case "Report-Overview":
                    var currentPageOverview = this.currentPageOverview;
                    if (currentPageOverview < this.totalPagesOverview) {
                        this.currentPageOverview = currentPageOverview + 1;
                        this.getOverviewData();
                    } else {
                        this.$message({
                            message: '没有更多了',
                            type: 'warning'
                        });
                    }
                    break;
            }
        }
    }
}
</script>

<style scoped>
.box {
    width: 1200px;
    margin: 5px auto;
}

.page-content-container {
    height: 800px;
    width: 100%;

    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;

}

.page-content-header {
    width: 100%;
    height: 80px;
    background: #F8FAFF;
    border-radius: 6px 5px 0px 0px;
    line-height: 80px;
    position: relative;
    display: flex;
}

.page-header-block {
    width: 6px;
    height: 24px;
    background: #4F79ED;
    border-radius: 0px 17px 17px 0px;
    position: absolute;
    left: 0px;
    top: 28px;
}

.page-content-header-item {
    width: 170px;
    height: 100%;
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.page-content-header-item:hover {
    color: #4F79ED;
    cursor: pointer;
}

.page-content-header-item-active {
    width: 170px;
    height: 100%;
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #4F79ED;
    background: #fff;
    cursor: pointer;
}

.page-content-wrapper {
    display: flex;
    height: 720px;
    overflow: hidden;
    overflow-y: auto;

}

.page-content {
    flex: 1;
    margin: 30px 41px 30px 45px;
}

.page-title-wrapper {
    display: flex;
    justify-content: space-between;
}

.sort-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
}

.page-mode-container {
    display: flex;
}

.page-title-item-active {
    width: 101px;
    height: 32px;
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%);
    border-radius: 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    margin-right: 15px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    animation: animi .5s;
}

.page-title-item {
    width: 101px;
    height: 32px;
    border-radius: 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    text-align: center;
    line-height: 32px;
    margin-right: 15px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    animation: animi .5s;
}

.page-title-item:hover {
    background: linear-gradient(90deg, #5580F5 0%, #72A3F5 100%);
    color: #fff;
    cursor: pointer;
}

.page-tab-container {
    display: flex;
    align-items: center;
    margin-top: 24px;
    height: 40px;
}

.page-tab-item {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
    margin-right: 34px;
    position: relative;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    animation: animi .5s;
    cursor: pointer;
}

.page-tab-item-active {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    margin-right: 34px;
    position: relative;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    animation: animi .5s;
    cursor: pointer;
}

.page-tab-gap {
    margin-left: 20px;
}

.tab-line {
    width: 22px;
    height: 6px;
    background: #4F79ED;
    border-radius: 3px;
    position: absolute;
    left: 50%;
    top: 32px;
    transform: translateX(-50%);
    animation: line .5s;
}

@keyframes line {
    0% {
        width: 0px
    }

    100% {
        width: 22px;
    }
}

.video-list {
    padding-top: 10px;
}

.page-mode-input-wrapper {
    display: flex;
    width: 235px;
    position: relative;
    top: -5px;
}

.page-mode-input>>>.el-input__inner {
    width: 160px !important;
    height: 38px !important;
    border-radius: 6px 0px 0px 6px !important;
    border: 1px solid #6D94FF !important;
    border-right: 0px !important;
}

.study-report-member-input-wrapper {
    display: flex;
}

.study-report-member-input-btn {
    cursor: pointer;
    width: 75px;
    height: 38px;
    background: #6D94FF;
    border-radius: 6px 6px 6px 6px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.input-btn {
    width: 75px;
    height: 38px;
    background: #6D94FF;
    border-radius: 0px 6px 6px 0px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.input-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.input-btn-icon {
    font-size: 13px;
}

.input-btn-label {
    margin-left: 5px;
}

.view-more-btn {
    width: 122px;
    height: 34px;
    border-radius: 20px;
    border: 1px solid #F69264;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F69568;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 50px;
    margin-bottom: 10px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.view-more-btn:hover {
    cursor: pointer;
    background: #F69264;
    color: #fff;
}
</style>


